/**
 * @ngdoc directive
 * @name donationformcoordinate
 *
 * @description
 * Donation Form coordinate
 */
module.directive('donationformcoordinate', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$scope', function ($scope) {
            /* error detection */
            $scope.hasError = function (model) {
                return $scope.donationForm.$submitted && ($scope.donationForm.coordinateForm[model].$error.required || $scope.donationForm.coordinateForm[model].$error.email || $scope.donationForm.coordinateForm[model].$error.pattern);
            };
        }],
        template:
                '  <section class="aqua-donationform-coordinate" ng-form="coordinateForm">' +
                '    <a name="coordonnees"></a>' +
                '    <div class="grid-main">' +
                '      <h2 class="grid grid-center"><span class="aqua-donationform-coordinate--title">Mes coordonnées</span></h2>' +

                '      <div class="grid grid-12 grid-center">' +

                '        <div class="aqua-form--warning grid-12" ng-if="donationForm.$submitted && donationForm.coordinateForm.$invalid">' +
                '          <p class="aqua-form--warning-message" ng-if="donationForm.coordinateForm.$error.required && (donationForm.coordinateForm.$error.required[0].$name !== \'montant\' || donationForm.coordinateForm.$error.required[1].$name !== \'montant\')">Veuillez renseigner les champs obligatoires.</p>' +
                '          <p class="aqua-form--warning-message" ng-if="donationForm.coordinateForm.telephone.$error.pattern">Veuillez renseigner le numéro de téléphone au format attendu.</p>' +
                '          <p class="aqua-form--warning-message" ng-if="donationForm.coordinateForm.email.$error.email">Veuillez renseigner l\'adresse email au format attendu.</p>' +
                '        </div>' +

                '        <div class="grid grid-5 grid-12-s">' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'civilite\')}">' +
                '            <p class="aqua-form--label grid-12">Civilité <span class="aqua-form--label-required">*</span></p>' +
                '            <div class="aqua-form--radios_deprecated grid-12">' +
                '              <label class="aqua-form--radio_deprecated-label" ng-class="{\'is-active\': formModel.civilite === \'m\'}"><input type="radio" name="civilite" class="aqua-form--radio_deprecated" ng-model="formModel.civilite" value="m" required> M.</label>' +
                '                /' +
                '              <label class="aqua-form--radio_deprecated-label" ng-class="{\'is-active\': formModel.civilite === \'mme\'}"><input type="radio" name="civilite" class="aqua-form--radio_deprecated" ng-model="formModel.civilite" value="mme" required> Mme</label>' +
                '            </div>' +
                '          </div>' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'prenom\')}">' +
                '            <label for="field_prenom" class="aqua-form--label grid-12">Prénom <span class="aqua-form--label-required">*</span></label>' +
                '            <input type="text" class="aqua-form--input grid-12" id="field_prenom" name="prenom" ng-model="formModel.prenom" required>' +
                '          </div>' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'nom\')}">' +
                '            <label for="field_nom" class="aqua-form--label grid-12">Nom <span class="aqua-form--label-required">*</span></label>' +
                '            <input type="text" class="aqua-form--input grid-12" id="field_nom" name="nom" ng-model="formModel.nom" required>' +
                '          </div>' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'email\')}">' +
                '            <label for="field_email" class="aqua-form--label grid-12">Email <span class="aqua-form--label-required">*</span></label>' +
                '            <input type="email" class="aqua-form--input grid-12" id="field_email" name="email" ng-model="formModel.email" required>' +
                '          </div>' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'telephone\')}">' +
                '            <label for="field_telephone" class="aqua-form--label grid-12">Téléphone</label>' +
                '            <input type="tel" class="aqua-form--input grid-12" id="field_telephone" name="telephone" ng-model="formModel.telephone" pattern="(0|\\+33)[1-9]([-. ]?\\d{2}){4}">' +
                '          </div>' +

                '        </div>' +

                '        <div class="grid grid-5 grid-12-s pull-1-ns">' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'adresse\')}">' +
                '            <label for="field_adresse" class="aqua-form--label grid-12">Adresse <span class="aqua-form--label-required">*</span></label>' +
                '            <input type="text" class="aqua-form--input grid-12" id="field_adresse" name="adresse" ng-model="formModel.adresse" google-places-autocomplete required>' +
                '          </div>' +

                '          <div class="aqua-form--field grid-12">' +
                '            <label for="field_complement" class="aqua-form--label grid-12">Complément d\'adresse</label>' +
                '            <input type="text" class="aqua-form--input grid-12" id="field_complement" name="complement" ng-model="formModel.complement">' +
                '          </div>' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'codepostal\')}">' +
                '            <label for="field_cp" class="aqua-form--label grid-12">Code postal <span class="aqua-form--label-required">*</span></label>' +
                '            <input type="number" class="aqua-form--input grid-12" id="field_cp" name="codepostal" ng-model="formModel.codepostal" min="0" required>' +
                '          </div>' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'ville\')}">' +
                '            <label for="field_ville" class="aqua-form--label grid-12">Ville <span class="aqua-form--label-required">*</span></label>' +
                '            <input type="text" class="aqua-form--input grid-12" id="field_ville" name="ville" ng-model="formModel.ville" required>' +
                '          </div>' +

                '          <div class="aqua-form--field grid-12" ng-class="{\'has-error\': hasError(\'pays\')}">' +
                '            <label for="field_pays" class="aqua-form--label grid-12">Pays <span class="aqua-form--label-required">*</span></label>' +
                '            <input type="text" class="aqua-form--input grid-12" id="field_pays" name="pays" ng-model="formModel.pays" required>' +
                '          </div>' +

                '        </div>' +

                '        <div class="grid grid-11 grid-12-s">' +
                '          <div class="aqua-form--field grid-12">' +

                '            <div class="aqua-form--checkboxes_deprecated grid-12">' +
                '              <label class="aqua-form--checkbox_deprecated-label" ng-class="{\'is-active\': formModel.supplements_glenansavenir}"><input type="checkbox" name="supplements_glenansavenir" ng-model="formModel.supplements_glenansavenir" class="aqua-form--checkbox_deprecated"> <span class="aqua-form--checkbox_deprecated-text">J’accepte de recevoir des informations du fond de dotation Glénans Avenir</span></label>' +
                '              <br>' +
                '              <label class="aqua-form--checkbox_deprecated-label" ng-class="{\'is-active\': formModel.supplements_glenans}"><input type="checkbox" name="supplements_glenans" ng-model="formModel.supplements_glenans" class="aqua-form--checkbox_deprecated"> <span class="aqua-form--checkbox_deprecated-text">J’accepte de recevoir des informations de l’association les Glénans</span></label>' +
                '            </div>' +

                '          </div>' +
                '        </div>' +

                '      </div>' +

                '    </div>' +
                '  </section>'
    };
});
